import React from 'react';
import { Backdrop, CircularProgress, Typography, Box } from '@mui/material';
import { ReactComponent as Logo } from "../../assets/logo.svg";

const FullScreenLoader = ({ open, message = "Loading..." }) => {
    return (
        <Backdrop
            sx={{
                color: '#fff',
                zIndex: (theme) => theme.zIndex.drawer + 1000,
                flexDirection: 'column',
                backgroundColor: 'rgba(0, 0, 0, 0.85)', // Dark and sleek
                backdropFilter: 'blur(5px)' // Adds a modern blur effect
            }}
            open={open}
        >
            <Logo
                style={{ height: 80, width: 80, marginBottom: 32, opacity: 0.9 }}
            />
            <CircularProgress color="inherit" size={60} thickness={4} />
            <Box mt={4}>
                <Typography
                    variant="h5"
                    component="div"
                    sx={{
                        fontWeight: 300,
                        letterSpacing: 2,
                        textTransform: 'uppercase',
                        fontSize: '1.2rem'
                    }}
                >
                    {message}
                </Typography>
            </Box>
        </Backdrop >
    );
};

export default FullScreenLoader;
